export const PROMOTION_TYPE_COMPANY = 'company'
export const PROMOTION_TYPE_USER = 'user'
export const PROMOTION_TYPE_ALLOWANCE = 'allowance'

export default {
    company: PROMOTION_TYPE_COMPANY,
    user: PROMOTION_TYPE_USER,
    allowance: PROMOTION_TYPE_ALLOWANCE,
}
